import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from "../static/footer/footer.component";
import { FooterHeaderComponent } from "../static/footer-header/footer-header.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-features-section',
  templateUrl: './features-section.component.html',
  styleUrls: ['./features-section.component.scss'],
  standalone: true,
  imports: [FooterComponent, FooterHeaderComponent,CommonModule]
})
export class FeaturesSectionComponent implements OnInit {

  isStandalonePage: boolean = false;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.isStandalonePage = !this.router.url.startsWith('/home');
    this.initAnimations();
  }

  private initAnimations(): void {
    // Animate cards on scroll
    setTimeout(() => {
      const cards = document.querySelectorAll('.testimonial-card');
      cards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('animate-in');
        }, index * 200);
      });
    }, 500);
  }
}
